import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Text, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import Checkbox from '@/components/checkbox';
import IconGlyph from '@/bit/components/components.icon-glyph';
import CustomLink from '@/bit/components/components.custom-link';
import {
  OPACITY_LAYOUT_COLORS,
  CONTENT_POSITION,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@/bit/components/components.modal';
import dynamic from 'next/dynamic';
import { actions as modalActions } from '@/bit/reducers/reducers.modals-reducer';
import { DEVICE_KIND } from '@/constants/constant';
import getDeviceKindDependsOnViewPort from '@gcloud-npm/utils.common.get-device-kind-depends-on-viewport';

function DateSelector({
  id,
  name,
  label,
  defaultValue,
  skipLabel = '',
  appointmentOptions = null,
  onChange = () => {},
  clearLabel = true,
}) {
  const dispatch = useDispatch();
  const [skipSmartAppointment, setSkipSmartAppointment] = useState(false);
  const [dateSelected, setDateSelected] = useState(null);
  const [dateLabel, setDateLabel] = useState(label);

  useEffect(() => {
    if (defaultValue) {
      const { day: date, end, start } = { ...defaultValue };
      const { day, month, year } = { ...date };
      const dateValue = `${day}-${month}-${year} de ${start} a ${end}`;
      setDateSelected({ ...defaultValue, dateValue });
      onChange({ ...defaultValue, dateValue });
    }
  }, [defaultValue]);

  const handleOnChangeSkipSmartAppointment = (e) => {
    const { target } = { ...e };
    const { checked } = { ...target };
    setSkipSmartAppointment(checked);
    onChange(checked ? null : dateSelected);
  };
  const handleOnSelectDate = (dateSelectedData) => {
    const { day: date, end, start } = { ...dateSelectedData };
    const { day, month, year } = { ...date };
    const dateValue = `${day}-${month}-${year} de ${start} a ${end}`;
    onChange({ ...dateSelectedData, dateValue });
    setDateSelected({ ...dateSelectedData, dateValue });
    if (clearLabel) {
      setDateLabel('');
    }
  };
  const handleSmartAppointment = () => {
    const deviceKind = getDeviceKindDependsOnViewPort();
    const CalendarModal = dynamic(() => import('@/modals/smartAppointment'));
    dispatch(
      modalActions.addModal({
        createAnchor: false,
        type: 'MODAL',
        id: 'changeDateCalendarModal',
        Element2Show: CalendarModal,
        elementProps: {
          availableDays: appointmentOptions,
          selectDate: handleOnSelectDate,
          dateSelected,
        },
        modalProps: {
          className: '',
          contentPosition:
            deviceKind === DEVICE_KIND.MOBILE
              ? CONTENT_POSITION.CENTER_BOTTOM
              : CONTENT_POSITION.CENTER_CENTER,
          opacityLayoutColor: OPACITY_LAYOUT_COLORS.BLACK05,
          inSceneEffect:
            deviceKind === DEVICE_KIND.MOBILE
              ? IN_SCENE_EFFECT.FADE_IN_BOTTOM
              : IN_SCENE_EFFECT.FADE_IN,
          outSceneEffect:
            deviceKind === DEVICE_KIND.MOBILE
              ? OUT_SCENE_EFFECT.FADE_OUT_BOTTOM
              : OUT_SCENE_EFFECT.FADE_OUT,
          closeByClickingOutside: true,
          contentInsideContainer: deviceKind !== DEVICE_KIND.MOBILE,
        },
      })
    );
  };
  return (
    <div className="date-selector">
      {!skipSmartAppointment && (
        <>
          <div className="date-selector__input">
            {dateLabel && (
              <div className="date-selector__label">
                <Text
                  text={dateLabel}
                  color={TEXT_COLOR.GREY4}
                  size={TEXT_SIZE.CAPTION3}
                  cyData="date-selector-change-date__label"
                />
              </div>
            )}

            <div className="date-selector__input--value">
              <IconGlyph
                id="reloj"
                alt="reloj-icono"
                kind="m"
                color="GREY4"
                layoutSize={{ width: 18, height: 18 }}
                cyData="date-selector-change-date__value-icon"
              />
              {dateSelected?.dateValue && (
                <Text
                  text={dateSelected?.dateValue}
                  color={TEXT_COLOR.GREY6}
                  size={TEXT_SIZE.CAPTION1}
                  cyData="date-selector-change-date__value"
                />
              )}
            </div>
          </div>
          <div className="date-selector__change-link">
            <CustomLink
              role="button"
              onClick={() => handleSmartAppointment()}
              taggingInfo={{
                componentName: 'link',
                componentVariation: 'all',
                componentContent: 'Cambiar fecha',
                componentPerso: '',
                componentProduct: '',
              }}
              ariaLabel="Cambiar fecha"
              cyData="date-selector-change-date__link"
            >
              <Text
                text="Cambiar fecha"
                color={TEXT_COLOR.BLUEA}
                size={TEXT_SIZE.CAPTION3}
                cyData="date-selector-change-date__link-text"
              />
            </CustomLink>
          </div>
        </>
      )}
      {skipLabel && (
        <div className="date-selector__skip-checkbox">
          <Checkbox
            name={`${id}-skip-checkbox`}
            id={`${name}-skip-checkbox`}
            onChange={handleOnChangeSkipSmartAppointment}
            checked={skipSmartAppointment}
          >
            <Text
              text={skipLabel}
              color={TEXT_COLOR.GREY6}
              kind={TEXT_KIND.SPAN}
              size={TEXT_SIZE.CAPTION2}
              display={TEXT_DISPLAY.INLINE}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
          </Checkbox>
        </div>
      )}
      <style jsx>
        {`
          .date-selector {
            display: flex;
            flex-direction: column;
            .date-selector__input {
              .date-selector__input--value {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 12px;
              }
            }
          }
          .date-selector__label {
            margin-bottom: 8px;
          }
          .date-selector > * {
            margin-bottom: 8px;
          }
          .date-selector > *:last-child {
            margin-bottom: 0px;
          }
        `}
      </style>
    </div>
  );
}
export default DateSelector;
